import { useTranslation } from "react-i18next"

import { Eye } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { MetadataDialog } from "@/features/chat/components/metadata-dialog"
import { useCitationPreview } from "@/features/chat/contexts/use-citation-preview"
import { useCitation } from "@/features/chat/hooks/use-citation"
import { KNOWN_SESSION_TYPES } from "@/types"

type ActiveCitationsDropdownProps = {
  citation: string
}

export function ActiveCitationsDropdown({ citation }: ActiveCitationsDropdownProps) {
  const { t } = useTranslation()

  const { openPreview } = useCitationPreview()
  const { openMetadataDialog, setOpenMetadataDialog, extraData } = useCitation()

  function handleShowDocument() {
    openPreview(citation, KNOWN_SESSION_TYPES.Navigator, {
      backLabel: t("questioninput.back_to_context", { defaultValue: "Back to context" }),
      preserveSidebarStack: true,
    })
  }

  const showDocumentLabel = t("answer.show_document")

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            aria-label={showDocumentLabel}
            className="h-7 w-7"
            size="icon"
            type="button"
            variant="ghost"
            onClick={handleShowDocument}
          >
            <Eye className="size-4 shrink-0" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{showDocumentLabel}</p>
        </TooltipContent>
      </Tooltip>

      <MetadataDialog
        extraData={extraData}
        openMetadataDialog={openMetadataDialog}
        setOpenMetadataDialog={setOpenMetadataDialog}
      />
    </>
  )
}
